var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#666666"},[React.createElement("path",{"d":"M16.6464466,6.64644661 L6.64644661,16.6464466 C6.17504209,17.1178511 6.88214887,17.8249579 7.35355339,17.3535534 L17.3535534,7.35355339 C17.8249579,6.88214887 17.1178511,6.17504209 16.6464466,6.64644661 Z","key":0}),React.createElement("path",{"d":"M7.35355339,6.64644661 L17.3535534,16.6464466 C17.8249579,17.1178511 17.1178511,17.8249579 16.6464466,17.3535534 L6.64644661,7.35355339 C6.17504209,6.88214887 6.88214887,6.17504209 7.35355339,6.64644661 Z","key":1})]));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/close.svg
// module id = 288
// module chunks = 0